import baseToString from "./_baseToString.js";
function toString(value) {
  return value == null ? "" : baseToString(value);
}
export default toString;
